export const QUICK_SEARCH_MAX_LENGTH_LIMITATION = 100
